import { useState } from "react";
import { GamePlayerContext } from "../../game/context/game-context";
import { requestNonce, verifyLogin } from "../../store/login.store";
import { getUserProfile } from "../../store/user.store";

export function AuthBasicService() {
    const [userPublicKey, setUserPublicKey] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isFetching, setIsFetching] = useState(false)
    const [user, setDataUser] = useState({})

    async function initialize() {
        const publicKeyUser = localStorage.getItem(`USER_PUBLIC_KEY`) ? localStorage.getItem(`USER_PUBLIC_KEY`) : null
        setUserPublicKey(publicKeyUser)
        const checkAuth = checkIsAuthenticated();
        if (checkAuth) {
            const getProfile = await getUserProfile();
            const generateUser = generateDataUser(getProfile)
            setDataUser(generateUser)

            return generateUser;
        }

        return null;
    }


    async function loginMetamask() {
        setIsFetching(true);
        if (window.ethereum) {
            metaMaskProvider = await web3Modal.connect();
            web3 = new Web3(metaMaskProvider);
            const accounts = await web3.eth.requestAccounts();

            await personalSign(accounts[0], 'metamask')

            Promise.resolve();

        } else {
            setIsFetching(false);
            return Promise.reject(
                new Error(
                    "Not set ethereum wallet or invalid. You need to install Metamask"
                )
            );
        }
    }

    async function setupAccountData(userVerified) {
        try {
            setIsFetching(true);
            
            const provider = 'custodial_wallet';
            const userData = userVerified.data;


            // setup local 
            localStorage.setItem(`BEARER`, userVerified.token);
            setUserPublicKey(userData.publicKey)
            localStorage.setItem(`USER_PUBLIC_KEY`, userData.publicKey);
            // assign to player setting
            const generateUser = generateDataUser(userVerified.data)
            console.log(generateUser, userVerified.data)
            setDataUser(generateUser);
            setIsAuthenticated(true);

            setIsFetching(false);
        } catch (err) {

            setIsFetching(false);
        } finally {

            setIsFetching(false);
        }
    }


    async function loginWalletconnect() {
        try {
            setIsFetching(true);
            await walletconnectProvider.enable();
            web3 = new Web3(walletconnectProvider);
            const accounts = await web3.eth.getAccounts();


            await personalSign(accounts[0], 'walletconnect')

            setIsFetching(false);
        } catch (err) {

            setIsFetching(false);
        } finally {

            setIsFetching(false);
        }
    }

    function checkIsAuthenticated() {
        const savedToken = localStorage.getItem(`BEARER`);

        let checkAuth = savedToken ? true : false;
        setIsAuthenticated(checkAuth);

        return checkAuth;
    }

    async function logOut() {
        localStorage.removeItem(`USER_PUBLIC_KEY`);
        localStorage.removeItem(`BEARER`);
        localStorage.removeItem(`skin_locale`);
        localStorage.removeItem(`local_player_setting`);
        setUserPublicKey(null);

        setIsAuthenticated(false);
        return Promise.resolve();
    }


    async function getUserIdentity(provider) {
        const providerUpper = provider.toLocaleUpperCase();
        const address = localStorage.getItem(`WALLET_ADDRESS_KEY`);
        if (!address) {
            return Promise.reject();
        }

        const balance = await getBalance(address);

        return Promise.resolve({
            address,
            balance,
        });
    }


    async function getBalance() {
        metaMaskProvider = await web3Modal.connect();
        const web3 = new Web3(metaMaskProvider);
        return new Promise((resolve, reject) => {
            web3.eth.getBalance(walletAddress, (err, result) => {
                if (err) {
                    // reject(err);
                } else {
                    resolve(web3.utils.fromWei(result, "ether"));
                }
            });
        });
    }

    function generateDataUser(user) {
        return { displayName: user.name, name: user.name, preset: user.preset, isAccountBinded: true, isProfileUpdated: user.isProfileUpdated, id: user.publicKey, userDefaultBase: user.userDefaultBase }
    }

    return {
        initialize,
        loginMetamask,
        isAuthenticated,
        checkIsAuthenticated,
        getUserIdentity,
        logOut,
        isFetching,
        getBalance,
        user,
        loginWalletconnect,
        setupAccountData,
    };
}

